import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../packages/ui';
import { getReviews } from '../../packages/api-client/work-api';
import { usePageTitle } from '../../hooks/usePageTitle';
import { WorkList } from './WorkList';

/**
 * /reviews — tasks in the review status that the caller may see, across
 * projects (GET /me/reviews). Decisions happen on the task itself; this page
 * shows the agent's latest handoff summary when one was posted.
 */
export function ReviewsPage() {
    usePageTitle('Reviews');
    return (
        <div className="work-page">
            <PageHeader title="Reviews"
                subtitle="Tasks in review that you can see, oldest update first. Open a task to review it and change its status." />
            <WorkList queryKey="reviews" fetchPage={getReviews} label="Tasks in review"
                emptyTitle="Nothing is waiting for review"
                emptyMessage="Tasks moved to In review in projects you can see will appear here."
                renderExtra={(item) => item.handoff_summary ? (
                    <div className="work-handoff">
                        <p className="work-handoff-label">Latest handoff summary</p>
                        <p className="work-handoff-body">{item.handoff_summary}</p>
                    </div>
                ) : (
                    <p className="work-handoff-none">
                        No handoff summary. <Link to={`/tasks/${item.id}`}>Open the task</Link> for its discussion and linked commits.
                    </p>
                )} />
        </div>
    );
}
